/* eslint-disable @nx/enforce-module-boundaries */
import React from 'react';
import { Box, Flex, HStack, Square, Stack, VStack } from '@mybridge/ui/layout';
import { Link } from '@mybridge/ui/link';
import { SeeMore } from '@mybridge/ui/see-more';
import { Skeleton } from '@mybridge/ui/skeleton';
import { Spinner } from '@mybridge/ui/spinner';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { PostBoxContext, usePostBoxContext } from '../context';
import { PostBoxHeader } from '../header';
import { Heading, Text, Image, Button, Card } from '@mybridge/ui';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { useRouter } from 'next/router';
import { EventDefaultImage } from '@mybridge/icons/EventDefaultImage';
import {
  EventCalendarLineIcon,
  EventClockIcon,
  EventHostIcon,
  LinkLineIcon,
  LocationLineIcon,
  Upload,
} from '@mybridge/icons';
import moment from 'moment';
import { getUserFullName } from 'v4/lib/commons';
import _ from 'lodash';
import { CALL_TO_ACTION } from 'v4/lib/data';
import Slider from 'react-slick';
import { AdCampaignDefaultImageIcon } from '@mybridge/icons/CampaignIcon';
import { ChildMediaDisplay } from '../child-media-display';
// import { convertLinksInText } from 'v4/utils/utils';
import { formatContent } from 'v4/utils/utils';

const SinglePostBody = ({ post, isOnlyPreview, postIndex }) => {
  const { push } = useRouter();
  const targetRef = useRef(null);
  const {
    hasInsights,
      isInFrame,
    showMedia = true,
    postModalLink,
    hasMedia,
    userProfileInfo,
    handleAdClicksRouting,
    setCurrentMediaToShow
  } = useContext(PostBoxContext);
  const {
    id,
    content,
    repost,
    type,
    title,
    author,
    company,
    excerpt,
    readers,
    slug,
    media,
    start_time,
    end_time,
    attendees,
    ad_format_detail,
    ad_format,
    description,
    child_posts,
  } = post;
  const repostBoxContext = usePostBoxContext({ post: repost });
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const quoted = repost && (content?.length || media);
  const isArticle = type === 3;
  const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
  // if (isArticle) {
  //   console.log(post);
  // }

  const isEvent = type === 2;
  const isAdPost = type === 4;
  const isProfilePicPost = post?.content === 'USER_PROFILE_PIC_UPDATE';
  const isProfileBannerPost =
    post?.content === 'USER_PROFILE_BANNER_PIC_UPDATE';

  const attending = attendees?.find?.(
    (a) => a?.user?.id === userProfileInfo?.id
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  // console.log('childpost', postIndex, post?.id);
  // console.log('isInFrame', post?.media?.length);

  return (
    <>
                
       <Box mt={2} style={{ width: '100%' }}>
          {content?.length && !isProfileBannerPost ? (
            <>
              <Box 
                // href={postModalLink?.(post?.parent_post)}
                onClick={(e) => {
                  const clickedLink = e.target.closest('a');
                  if (clickedLink && clickedLink !== e.currentTarget) {
                    e.stopPropagation();
                    return;
                  }
                  push(postModalLink?.(post?.parent_post))
                }}
              >
                <Text
                  color="brandGray.700"
                  pl={side === 'rtl' ? "60px" : 2}
                  pr={side === 'rtl' ? 2 :"60px"}
                  pb={post?.media?.length > 0 ? 4 : 0}
                  dangerouslySetInnerHTML={{
                    // __html: convertLinksInText(content),
                    __html: formatContent(content, post?.mention_users),
                  }}
                  fontSize="md"
                />
                { media?.[0]?.file ? (
                  <Stack
                    pl={side === 'rtl' ? "60px" : 2}
                    pr={side === 'rtl' ? 2 :"60px"}
                    w="100%"
                    minH={!showMedia && hasMedia && media.length && !mediaLoaded ? '300px' : '0'}
                    pos="relative"
                  >
                    {!showMedia && media ? (
                      <Box
                        overflow="hidden"
                        w="100%"
                        // href={postModalLink?.(post?.id)}
                        onClick={() => setCurrentMediaToShow(media?.[0]?.file) }
                      >
                        <ChildMediaDisplay
                          outerTimeStyle={{ left: '42px' }}
                          onLoaded={() => setMediaLoaded(true)}
                          post={post}
                        />
                      </Box>
                    ) : ''}
                  </Stack>
                ) : <></>}
              </Box>
            </>
          ) : media?.[0]?.file ? (
            <Stack
              pl={side === 'rtl' ? "60px" : 2}
              pr={side === 'rtl' ? 2 :"60px"}
              w="100%"
              minH={!showMedia && hasMedia && media.length && !mediaLoaded ? '300px' : '0'}
              pos="relative"
            >
              {!showMedia && media ? (
                <Box
                  overflow="hidden"
                  w="100%"
                  // href={postModalLink?.(post?.id)}
                  onClick={() => setCurrentMediaToShow(media?.[0]?.file) }
                >
                  <ChildMediaDisplay
                    outerTimeStyle={{ left: '42px' }}
                    onLoaded={() => setMediaLoaded(true)}
                    post={post}
                  />
                </Box>
              ) : ''}
            </Stack>
          ) : <></>}

          {!isEvent && !isAdPost ? (
            <Stack
              pl={side === 'rtl' ? "60px" : 2}
              pr={side === 'rtl' ? 2 :"60px"}
              w="100%"
              minH={
                showMedia && hasMedia && media.length && !mediaLoaded
                  ? '300px'
                  : '0'
              }
              pos="relative"
            >
              {showMedia && media ? (
                <Box
                  // maxH={'400px'}
                  overflow="hidden"
                  w="100%"
                  // href={postModalLink?.(post?.id)}
                  onClick={() => setCurrentMediaToShow(media?.[0]?.file) }
                >
                  <ChildMediaDisplay
                    outerTimeStyle={{ left: '42px' }}
                    onLoaded={() => setMediaLoaded(true)}
                    post={post}
                  />
                </Box>
              ) : (
                ''
              )}
            </Stack>
          ) : (
            ''
          )}

          <Stack spacing={0}>
            {repost ? (
              <PostBoxContext.Provider value={repostBoxContext}>
                <Box
                  {...(quoted
                    ? {
                        mx: 4,
                        mt: hasMedia ? 0 : 2,
                        mb: hasInsights ? 0 : 2,
                        overflow: 'hidden',
                        border: '1px solid',
                        borderColor: 'gray.200',
                        borderRadius: 5,
                      }
                    : {})}
                >
                  {quoted ? <PostBoxHeader actionMenuEnabled={false} /> : ''}
                  <SinglePostBody />
                </Box>
              </PostBoxContext.Provider>
            ) : (
              ''
            )}
          </Stack>
        </Box>
    </>
  );
};

export default SinglePostBody;
